import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-lti-page-panel',
  template: '<ng-content />',
  styleUrls: ['lti-page-panel.component.scss']
})
export class LtiPagePanelComponent {
}
